import script from "./ReportsGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsGeneral.vue?vue&type=script&setup=true&lang=js"

import "./ReportsGeneral.vue?vue&type=style&index=0&id=43498ed2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43498ed2"]])

export default __exports__